import React, { Component } from "react";
import axios from "axios";
import { BrowserRouter, Route, Navigate } from "react-router-dom";
import { Panel } from "primereact/panel";
import DatePicker from "react-datepicker2";
import moment from "moment-jalaali";
import Server from "./../Server.js";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Card } from "primereact/card";
import { InputNumber } from "primereact/inputnumber";
import { SelectButton } from "primereact/selectbutton";
import { Tag } from "primereact/tag";
import { connect } from "react-redux";
import { Loader } from "rsuite";
import { Toast } from "primereact/toast";

class TravelRobot extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();

    this.toast = React.createRef();

    this.CreateForm = this.CreateForm.bind(this);
    this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
    this.SetEvent = this.SetEvent.bind(this);

    this.state = {
      layout: "list",
      name: "",
      ShopsList: [],
      type: "1",
      FId: "",
      DbTableName: "",
      usersList: [],
      DBTableField: "",
      latinName: "",
      group: {},
      code:null,
      type:"getCapacity",
      CountArr: {
        adult: 0,
        kid: 0,
        baby: 0,
      },
    };
  }
  isMobile(){
    if (window.innerWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }
  }
  componentDidMount() {
    this.isMobile();

    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        loading: 0,
      });
      that.getEvents();
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  }
  SetEvent() {
    let that = this;
    if(!this.state.date){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "تاریخ را وارد کنید ",
        life: 3000,
      });
      return;
    }
    if(this.state.date.indexOf("-") == -1){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "فرمت تاریخ نادرست است",
        life: 3000,
      });
      return;
    }
    if(!this.state.fromCity){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "شهر مبدا را وارد کنید ",
        life: 3000,
      });
      return;
    }
    if(!this.state.toCity){
      this.toast.current.show({
        severity: "warn",
        summary: "",
        detail: "شهر مقصد را وارد کنید ",
        life: 3000,
      });
      return;
    }
    let numberOfAdult = this.state.numberOfAdult;
    let numberOfKid = this.state.numberOfKid;
    let numberOfBaby = this.state.numberOfBaby;
    const list = [];
    let index = 0;
    let number = 1;
    if(this.state.type === "setReserve"){

   
    for (let i = 0; i < this.state.CountArr.adult; i++) {
      if (this.state["name_adult_" + i] && !this.state["disabled_adult_" + i]) {
        list[index] = {
          nationalCode: this.state["nationalCode_adult_" + i],
          name: this.state["name_adult_" + i],
          family: this.state["family_adult_" + i],
          lname: this.state["lname_adult_" + i],
          lfamily: this.state["lfamily_adult_" + i],
          birthDate: this.state["birthDate_adult_" + i]
            ? this.state["birthDate_adult_" + i]
                .local("en")
                .format("jYYYY-jM-jD")
            : "",
          birthDate_en: this.state["birthDate_adult_" + i]
            ? this.state["birthDate_adult_" + i].local("en").format("YYYY-M-D")
            : "",
          passportNum: this.state["passportNum_adult_" + i],
          passportDate: this.state["passportDate_adult_" + i],
          passenger: this.state["passenger_adult_" + i],
          mobile: this.state["mobile_adult_" + i],
          type: "adult",
        };
        index++;
        number++;
      } else if (this.state["disabled_adult_" + i]) {
        numberOfAdult--;
      }
    }
    for (let i = 0; i < this.state.CountArr.kid; i++) {
      if (this.state["name_kid_" + i] && !this.state["disabled_kid_" + i]) {
        list[index] = {
          nationalCode: this.state["nationalCode_kid_" + i],
          name: this.state["name_kid_" + i],
          family: this.state["family_kid_" + i],
          lname: this.state["lname_kid_" + i],
          lfamily: this.state["lfamily_kid_" + i],
          birthDate: this.state["birthDate_kid_" + i]
            ? this.state["birthDate_kid_" + i].local("en").format("jYYYY-jM-jD")
            : "",
          birthDate_en: this.state["birthDate_kid_" + i]
            ? this.state["birthDate_kid_" + i].local("en").format("YYYY-M-D")
            : "",
          passportNum: this.state["passportNum_kid_" + i],
          passportDate: this.state["passportDate_kid_" + i],
          passenger: this.state["passenger_kid_" + i],
          mobile: this.state["mobile_kid_" + i],
          type: "kid",
        };
        number++;
        index++;
      } else if (this.state["disabled_kid_" + i]) {
        numberOfKid--;
      }
    }
    for (let i = 0; i < this.state.CountArr.baby; i++) {
      if (this.state["name_baby_" + i] && !this.state["disabled_baby_" + i]) {
        list[index] = {
          nationalCode: this.state["nationalCode_baby_" + i],
          name: this.state["name_baby_" + i],
          family: this.state["family_baby_" + i],
          lname: this.state["lname_baby_" + i],
          lfamily: this.state["lfamily_baby_" + i],
          birthDate: this.state["birthDate_baby_" + i]
            ? this.state["birthDate_baby_" + i]
                .local("en")
                .format("jYYYY-jM-jD")
            : "",
          birthDate_en: this.state["birthDate_baby_" + i]
            ? this.state["birthDate_baby_" + i].local("en").format("YYYY-M-D")
            : "",
          passportNum: this.state["passportNum_baby_" + i],
          passportDate: this.state["passportDate_baby_" + i],
          passenger: this.state["passenger_baby_" + i],
          mobile: this.state["mobile_baby_" + i],
          type: "baby",
        };
        index++;
      } else if (this.state["disabled_baby_" + i]) {
        numberOfBaby--;
      }
    }
}
    let param = {
        code: this.state.code,  
      fTitle: this.state.fTitle,
      lTitle: this.state.lTitle,
      mobile: this.state.mobile,
      type: this.state.type,
      fromCity: this.state.fromCity,
      toCity: this.state.toCity,
      airLine: this.state.airLine,
      supplier: this.state.supplier,
      date: this.state.date,
      sendSms: this.state.sendSms,
      status: this.state.status,
      done: this.state.done,
      numberOfAdult:numberOfAdult,
      numberOfBaby: numberOfBaby,
      numberOfKid: numberOfKid,
      list: list,
    };
    this.setState({
      HasErrorForMaps: null,
      loading: 1,
    });
    let SCallBack = function (response) {
      that.onHideFormsDialog();
      that.getEvents();
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "success",
        summary: "",
        detail: "عملیات با موفقیت انجام شد",
        life: 3000,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "عملیات انجام نشد",
        life: 3000,
      });
    };
    this.Server.send("AdminApi/setRobotEvent", param, SCallBack, ECallBack);
  }
  CreateForm() {
    let list = [{}];
    for (let i = 0; i < this.state.CountArr.adult; i++) {
      list["name_adult_" + i] = "";
      list["family_adult_" + i] = "";
      list["lname_adult_" + i] = "";
      list["lfamily_adult_" + i] = "";
      list["birthDate_adult_" + i] = moment();
      list["passportNum_adult_" + i] = "";
      list["passportDate_adult_" + i] = "";
      list["nationalCode_adult_" + i] = "";
      list["mobile_adult_" + i] = "";
      list["passenger_adult_" + i] = "Mr";
      list["disabled_adult_" + i] = false;
    }
    for (let i = 0; i < this.state.CountArr.kid; i++) {
      list["name_kid_" + i] = "";
      list["family_kid_" + i] = "";
      list["lname_kid_" + i] = "";
      list["lfamily_kid_" + i] = "";
      list["birthDate_kid_" + i] = moment();
      list["passportNum_kid_" + i] = "";
      list["passportDate_kid_" + i] = "";
      list["nationalCode_kid_" + i] = "";
      list["mobile_kid_" + i] = "";
      list["passenger_kid_" + i] = "Mr";
      list["disabled_kid_" + i] = false;
    }
    for (let i = 0; i < this.state.CountArr.baby; i++) {
      list["name_baby_" + i] = "";
      list["family_baby_" + i] = "";
      list["lname_baby_" + i] = "";
      list["lfamily_baby_" + i] = "";
      list["birthDate_baby_" + i] = moment();
      list["passportNum_baby_" + i] = "";
      list["passportDate_baby_" + i] = "";
      list["nationalCode_baby_" + i] = "";
      list["mobile_baby_" + i] = "";
      list["passenger_baby_" + i] = "Mr";
      list["disabled_baby_" + i] = false;
    }
    this.setState({
        code:null,
      _id: null,
      visibleManageField: true,
      fTitle: "",
      lTitle: "",
      mobile: "",
      type: "getCapacity",
      fromCity: "",
      toCity: "",
      airLine: "",
      supplier: "",
      date: "",
      sendSms: "",
      status: false,
      done: false,
      numberOfAdult: 0,
      numberOfBaby: 0,
      numberOfKid: 0,
      CountArr: {
        adult: 0,
        kid: 0,
        baby: 0,
      },
      ...list,
    });
  }
  onHideFormsDialog(event) {
    this.setState({
      visibleManageField: false,
      selectedId: null,
    });
  }
  selectedComponentChange(value) {
    let that = this;
    var p = [];
    let countAdult = 0;
    let countKid = 0;
    let countBaby = 0;
    let list = [];
    for (let i = 0; i < value.list.length; i++) {
      if (value.list[i].type == "adult") {
        list["name_adult_" + countAdult] = value.list[i].name || "";
        list["family_adult_" + countAdult] = value.list[i].family || "";
        list["lname_adult_" + countAdult] = value.list[i].lname || "";
        list["lfamily_adult_" + countAdult] = value.list[i].lfamily || "";
        list["birthDate_adult_" + countAdult] =
          value.list[i].birthDate || ""
            ? moment(value.list[i].birthDate, "jYYYY-jM-jD")
            : moment();
        list["passportNum_adult_" + countAdult] =
          value.list[i].passportNum || "";
        list["passportDate_adult_" + countAdult] =
          value.list[i].passportDate || "";
        list["nationalCode_adult_" + countAdult] =
          value.list[i].nationalCode || "";
        list["mobile_adult_" + countAdult] =
          value.list[i].mobile || "";
        list["passenger_adult_" + countAdult] =
          value.list[i].passenger || "Mr";
        countAdult++;
       
      }
      if (value.list[i].type == "kid") {
        list["name_kid_" + countKid] = value.list[i].name || "";
        list["family_kid_" + countKid] = value.list[i].family || "";
        list["lname_kid_" + countKid] = value.list[i].lname || "";
        list["lfamily_kid_" + countKid] = value.list[i].lfamily || "";
        list["birthDate_kid_" + countKid] = value.list[i].birthDate
          ? moment(value.list[i].birthDate, "jYYYY-jM-jD")
          : moment();
        list["passportNum_kid_" + countKid] = value.list[i].passportNum || "";
        list["passportDate_kid_" + countKid] = value.list[i].passportDate || "";
        list["nationalCode_kid_" + countKid] = value.list[i].nationalCode || "";
        list["mobile_kid_" + countKid] =
          value.list[i].mobile || "";
        list["passenger_kid_" + countKid] =
          value.list[i].passenger || "Mr";
        countKid++;
      }
      if (value.list[i].type == "baby") {
        list["name_baby_" + countBaby] = value.list[i].name || "";
        list["family_baby_" + countBaby] = value.list[i].family || "";
        list["lname_baby_" + countBaby] = value.list[i].lname || "";
        list["lfamily_baby_" + countBaby] = value.list[i].lfamily || "";
        list["birthDate_baby_" + countBaby] = value.list[i].birthDate
          ? moment(value.list[i].birthDate, "jYYYY-jM-jD")
          : moment();
        list["passportNum_baby_" + countBaby] = value.list[i].passportNum || "";
        list["passportDate_baby_" + countBaby] =
          value.list[i].passportDate || "";
        list["nationalCode_baby_" + countBaby] =
          value.list[i].nationalCode || "";
        list["mobile_baby_" + countBaby] =
          value.list[i].mobile || "";
        list["passenger_baby_" + countBaby] =
          value.list[i].passenger || "Mr";
        countBaby++;
      }
    }
    this.setState({
      code: value.code,
      _id: value._id,
      fTitle: value.fTitle,
      lTitle: value.lTitle,
      mobile: value.mobile,
      type: value.type,
      fromCity: value.fromCity,
      toCity: value.toCity,
      airLine: value.airLine,
      supplier: value.supplier,
      date: value.date,
      sendSms: value.sendSms,
      status: value.status,
      done: value.done,
      mobile: value.mobile,
      visibleManageField: true,
      numberOfAdult: value.numberOfAdult,
      numberOfBaby: value.numberOfBaby,
      numberOfKid: value.numberOfKid,
      CountArr: {
        adult: countAdult,
        kid: countKid,
        baby: countBaby,
      },
      ...list,
    });
  }
  getEvents() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      GetAll: 1,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        GridDataFields: response.data.result,
      });
      that.setState({
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("AdminApi/getRobotEvent", param, SCallBack, ECallBack);
  }
  itemTemplate(brand) {
    return (
      <div
        className="p-clearfix"
        style={{ direction: "rtl", maxWidth: "100%" }}
      >
        <div
          style={{ margin: "10px 10px 0 0" }}
          className="row"
          username={brand.username}
        >
          <div
            className="col-8"
            username={brand.username}
            style={{ textAlign: "right" }}
          >
            <span
              className="iranyekanwebregular"
              style={{ textAlign: "right", overflow: "hidden" }}
              username={brand.username}
            >
              <span
                style={{ whiteSpace: "pre-wrap" }}
                username={brand.username}
              >
                {brand.name}
              </span>
              <br />
            </span>
          </div>
        </div>
      </div>
    );
  }
  render() {
    const typeTemplate = (rowData, props) => {
        if (rowData.type == "setReserve") {
          return <span>رزرو پرواز</span>;
        } else {
          return <span>اطلاع رسانی ظرفیت پرواز</span>;
        }
      };
      const statusTemplate = (rowData, props) => {
        if (rowData.status) {
          return (<div>
            <Tag  severity="primary" value={<div style={{width:70,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
             <i className="fa fa-check-circle" ></i>
             <span>فعال</span></div>
            } >
             </Tag>
           </div>);
        } else {
          return (<div>
            <Tag  severity="danger" value={<div style={{width:70,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
             <i className="fa fa-ban" ></i>
             <span>غیر فعال</span></div>
            } >
             </Tag>
           </div>);
        }
      };
      const doneTemplate = (rowData, props) => {
        if (rowData.done) {
          return (<div>
           <Tag  severity="success" value={<div style={{width:70,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <i className="fa fa-thumbs-up" ></i>
            <span>انجام شده</span></div>
           } >
            </Tag>
          </div>);
        } else {
          return (<div>
            <Tag  severity="info" value={<div style={{width:70,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
             <i className="fas fa-spinner fa-pulse" ></i>
             <span>در حال انجام</span></div>
            } >
             </Tag>
           </div>);
        }
      };

      
    const footer = (
      <div>
        <button
          className="btn btn-primary irsans"
          onClick={this.SetEvent}
          style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}
        >
          {" "}
          اعمال{" "}
        </button>
      </div>
    );
    return (
      <div style={{ direction: "rtl" }}>
        <Toast
          ref={this.toast}
          position="top-left"
          style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
        />
        {this.state.loading == 1 && (
          <div
            style={{
              position: "fixed",
              zIndex: 2000,
              top: 10,
              left: 15,
              backgroundColor: "#e89f31",
              padding: "2px 20px",
            }}
          >
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        )}
        <div className="row justify-content-center mt-2">
          <div className="col-12" style={{ background: "#fff" }}>
            <Panel
              header="رویدادها"
              style={{ textAlign: "right", fontFamily: "yekan" }}
            >
              <div className="row">
                <div className="col-6" style={{ textAlign: "right" }}>
                  <button
                    className="btn btn-primary irsans"
                    onClick={this.CreateForm}
                    style={{
                      width: "200px",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    ایجاد رویداد جدید
                  </button>
                </div>
              </div>

              <DataTable
                responsive
                value={this.state.GridDataFields}
                selectionMode="single"
                stripedRows
                selection={this.state.selectedComponent}
                onSelectionChange={(e) => this.selectedComponentChange(e.value)}
              >
                <Column
                  field="code"
                  header="کد"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="fromCity"
                  header="شهر مبدا"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="toCity"
                  header="شهر مقصد"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="date"
                  header="تاریخ"
                  className="irsans"
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="type"
                  header="نوع"
                  className="irsans"
                  style={{ textAlign: "right" }}
                  body={typeTemplate}

                />
                <Column
                  field="status"
                  header="وضعیت"
                  className="irsans"
                  body={statusTemplate}
                  style={{ textAlign: "right" }}
                />
                <Column
                  field="status"
                  header="انجام کار"
                  className="irsans"
                  body={doneTemplate}
                  style={{ textAlign: "right" }}
                />
              </DataTable>
            </Panel>
          </div>
        </div>

        <Dialog
          header={this.state.selectedId ? "مشاهده" : "ساخت رویداد جدید"}
          visible={this.state.visibleManageField}
          footer={footer}
          minY={70}
          onHide={this.onHideFormsDialog}
          maximizable={true}
          maximized={true}

        >
          <form>
            <div className="row" style={{ alignItems: "baseline" }}>
              
              <div className="col-lg-12 col-12 mt-2 mb-2">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <label className="labelNoGroup irsans">نوع</label>
                  <select
                    className="form-control irsans"
                    style={{ width: 300 }}
                    value={this.state.type}
                    onChange={(event) => {
                      this.setState({
                        type: event.target.value,
                      });
                    }}
                  >

                    <option value="getCapacity">اطلاع رسانی ظرفیت پرواز</option>
                    <option value="setReserve">رزرو پرواز</option>
                  </select>
                </div>
              </div>
              {(this.state.type == "getCapacity" ||
                this.state.type == "setReserve") && (
                <div className="row mt-3 mb-3">
                  <div className="col-lg-6 col-12">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label className="labelNoGroup irsans">شهر مبدا</label>
                      <select
                        className="form-control irsans"
                        value={this.state.fromCity}
                        onChange={(event) => {
                          this.setState({
                            fromCity: event.target.value,
                          });
                        }}
                      >
                        <option value=""></option>

                        <option value="ifn">اصفهان</option>
                        <option value="njf">نجف</option>
                        <option value="mhd">مشهد</option>
                        <option value="kih">کیش</option>
                        <option value="gsm">قشم</option>
                        <option value="thr">تهران</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label className="labelNoGroup irsans">شهر مقصد</label>
                      <select
                        className="form-control irsans"
                        value={this.state.toCity}
                        onChange={(event) => {
                          this.setState({
                            toCity: event.target.value,
                          });
                        }} 
                      >
                        <option value=""></option>
                        <option value="ifn">اصفهان</option>
                        <option value="njf">نجف</option>
                        <option value="mhd">مشهد</option>
                        <option value="kih">کیش</option>
                        <option value="gsm">قشم</option>
                        <option value="thr">تهران</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12 mt-2">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label className="labelNoGroup irsans">خط پروازی</label>
                      <select
                        className="form-control irsans"
                        value={this.state.airLine}
                        onChange={(event) => {
                          this.setState({
                            airLine: event.target.value,
                          });
                        }}
                      >
                        <option value=""></option>
                        <option value="29">ایران آسمان</option>
                        <option value="32">معراج</option>
                        <option value="863">وارش</option>
                        <option value="863">وارش</option>
                        <option value="9">زاگرس ایر</option>
                        <option value="1">تابان ایر</option>
                        <option value="5">کاسپین ایر</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12 mt-2">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label className="labelNoGroup irsans">تامین کننده</label>
                      <select
                        className="form-control irsans"
                        value={this.state.supplier}
                        onChange={(event) => {
                          this.setState({
                            supplier: event.target.value,
                          });
                        }}
                      >
                        <option value=""></option>
                        <option value="4020">شنتیا</option>
                        <option value="1866">ثامن الائمه سپاهان</option>
                        <option value="1892">هالی تور</option>

                        
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 col-12 mt-2">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label className="labelNoGroup irsans">تاریخ</label>
                      <input
                        className="form-control irsans"
                        autoComplete="off"
                        style={{ direction: "ltr" }}
                        type="text"
                        value={this.state.date}
                        name="date"
                        onChange={(event) =>
                          this.setState({ date: event.target.value })
                        }
                        placeholder="1401-01-01"
                        required="true"
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="col-lg-6 col-12">
                <div
                  style={{
                    textAlign: "right",
                    display: "flex",
                    alignItems: "flex-start",
                    padding: 10,
                  }}
                >
                  <Checkbox
                    inputId="sendSms"
                    value={this.state.sendSms}
                    checked={this.state.sendSms}
                    onChange={(e) => this.setState({ sendSms: e.checked })}
                  ></Checkbox>
                  <label
                    htmlFor="sendSms"
                    className="p-checkbox-label yekan"
                    style={{ paddingRight: 5 }}
                  >
                    ارسال پیامک
                  </label>
                </div>
              </div>
              {this.state.sendSms && (
                <div className="col-lg-12 col-12">
                  <div className="group">
                    <input
                      className="form-control irsans"
                      autoComplete="off"
                      style={{ direction: "ltr" }}
                      type="text"
                      value={this.state.mobile}
                      name="mobile"
                      onChange={(event) =>
                        this.setState({ mobile: event.target.value })
                      }
                      required="true"
                    />
                    <label> تلفن همراه - با کاما جدا کنید</label>
                  </div>
                </div>
              )}
              <div className="col-lg-12 col-12">
                <div
                  style={{
                    textAlign: "right",
                    display: "flex",
                    alignItems: "flex-start",
                    padding: 10,
                  }}
                >
                  <Checkbox
                    inputId="status"
                    value={this.state.status}
                    checked={this.state.status}
                    onChange={(e) => this.setState({ status: e.checked })}
                  ></Checkbox>
                  <label
                    htmlFor="status"
                    className="p-checkbox-label yekan"
                    style={{ paddingRight: 5 }}
                  >
                    فعال
                  </label>
                </div>
              </div>
              <div className="col-lg-12 col-12">
                <div
                  style={{
                    textAlign: "right",
                    display: "flex",
                    alignItems: "flex-start",
                    padding: 10,
                  }}
                >
                  <Checkbox
                    inputId="done"
                    value={this.state.done}
                    checked={this.state.done}
                    onChange={(e) => this.setState({ done: e.checked })}
                  ></Checkbox>
                  <label
                    htmlFor="done"
                    className="p-checkbox-label yekan"
                    style={{ paddingRight: 5 }}
                  >
                   انجام شده
                  </label>
                </div>
              </div>
              {this.state.type == "setReserve" && (
                <Panel
                  header={`مشخصات مسافران ${
                    this.state.travelerId && this.state.inserted
                      ? `(ثبت شده توسط : ${this.state.inserted})`
                      : ""
                  }`}
                  style={{ textAlign: "right", fontFamily: "yekan" }}
                >
                  <div>
                    <div className="row mb-3">
                      <div class="col-lg-3 col-12">
                        <div
                          style={{
                            textAlign: "right",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <label>
                            <Tag
                              severity="success"
                              value="تعداد بزرگسال"
                              className="mb-2"
                            ></Tag>
                          </label>
                          <InputNumber
                            value={this.state.numberOfAdult}
                            style={{ direction: "ltr" }}
                            inputStyle={{
                              borderRadius: 0,
                              padding: 0,
                              textAlign: "center",
                              fontSize: 20,
                            }}
                            mode="decimal"
                            showButtons
                            onValueChange={(e) => {
                              let CountArr = this.state.CountArr;
                              CountArr["adult"] = e.value;
                              this.setState({
                                numberOfAdult: e.value,
                                CountArr: CountArr,
                              });
                            }}
                            min={0}
                            max={1000}
                          />
                        </div>
                      </div>
                      <div class="col-lg-3 col-12 mt-md-0 mt-2">
                        <div
                          style={{
                            textAlign: "right",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <label>
                            <Tag
                              severity="info"
                              value="تعداد کودک"
                              className="mb-2"
                            ></Tag>
                          </label>
                          <InputNumber
                            value={this.state.numberOfKid}
                            style={{ direction: "ltr" }}
                            inputStyle={{
                              borderRadius: 0,
                              padding: 0,
                              textAlign: "center",
                              fontSize: 20,
                            }}
                            mode="decimal"
                            showButtons
                            onValueChange={(e) => {
                              let CountArr = this.state.CountArr;
                              CountArr["kid"] = e.value;
                              this.setState({
                                numberOfKid: e.value,
                                CountArr: CountArr,
                              });
                            }}
                            min={0}
                            max={1000}
                          />
                        </div>
                      </div>
                      <div class="col-lg-3 col-12 mt-md-0 mt-2">
                        <div
                          style={{
                            textAlign: "right",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <label>
                            <Tag
                              severity="warning"
                              value="تعداد نوزاد"
                              className="mb-2"
                            ></Tag>
                          </label>
                          <InputNumber
                            value={this.state.numberOfBaby}
                            style={{ direction: "ltr" }}
                            inputStyle={{
                              borderRadius: 0,
                              padding: 0,
                              textAlign: "center",
                              fontSize: 20,
                            }}
                            mode="decimal"
                            showButtons
                            onValueChange={(e) => {
                              let CountArr = this.state.CountArr;
                              CountArr["baby"] = e.value;
                              this.setState({
                                numberOfBaby: e.value,
                                CountArr: CountArr,
                              });
                            }}
                            min={0}
                            max={1000}
                          />
                        </div>
                      </div>
                    </div>
                    <Card className="mt-3">
                      {(this.state.CountArr.adult > 0 ||
                        this.state.CountArr.kid > 0 ||
                        this.state.CountArr.baby > 0) && (
                        <div
                          style={{
                            alignItems: "baseline",
                            display: this.state.isMobile ? "none" : "flex",
                          }}
                          className="mt-3"
                        >
                          <div
                            style={{
                              width: 150,
                              marginLeft: 8,
                              textAlign: "center",
                            }}
                          >
                            <label>نام فارسی</label>
                          </div>
                          <div
                            style={{
                              width: 150,
                              marginLeft: 8,
                              textAlign: "center",
                            }}
                          >
                            <label>نام خانوادگی فارسی</label>
                          </div>
                          <div
                            style={{
                              width: 150,
                              marginLeft: 8,
                              textAlign: "center",
                            }}
                          >
                            <label>نام لاتین</label>
                          </div>
                          <div
                            style={{
                              width: 150,
                              marginLeft: 8,
                              textAlign: "center",
                            }}
                          >
                            <label>نام خانوادگی لاتین</label>
                          </div>
                          <div
                            style={{
                              width: 150,
                              marginLeft: 8,
                              textAlign: "center",
                            }}
                          >
                            <label>کد ملی</label>
                          </div>
                          <div
                            style={{
                              width: 150,
                              marginLeft: 8,
                              textAlign: "center",
                            }}
                          >
                            <label>تاریخ تولد</label>
                          </div>
                          <div
                            style={{
                              width: 150,
                              marginLeft: 8,
                              textAlign: "center",
                            }}
                          >
                            <label>شماره گذرنامه</label>
                          </div>
                          <div
                            style={{
                              width: 150,
                              marginLeft: 8,
                              textAlign: "center",
                            }}
                          >
                            <label>تاریخ انقضا گذرنامه</label>
                          </div>
                          <div
                            style={{
                              width: 150,
                              marginLeft: 8,
                              textAlign: "center",
                            }}
                          >
                            <label>جنسیت</label>
                          </div>
                          <div
                            style={{
                              width: 150,
                              marginLeft: 8,
                              textAlign: "center",
                            }}
                          >
                            <label>شماره موبایل</label>
                          </div>
                          <div
                            style={{
                              width: 150,
                              marginLeft: 8,
                              textAlign: "center",
                            }}
                          ></div>
                        </div>
                      )}

                      {Array.from(
                        Array(parseInt(this.state.CountArr.adult)).keys()
                      ).map((item, index) => {
                        return (
                          <div
                            style={{
                              alignItems: "baseline",
                              display: "flex",
                              flexWrap: this.state.isMobile ? "wrap" : "nowrap",
                            }}
                            className="mt-2 p-message p-message-success"
                          >
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  placeholder={
                                    this.state.isMobile ? "نام فارسی" : ""
                                  }
                                  disabled={
                                    this.state["disabled_adult_" + index]
                                  }
                                  type="text"
                                  id={"name_adult_" + index}
                                  name={"name_adult_" + index}
                                  value={this.state["name_adult_" + index]}
                                  onChange={(event) => {
                                    this.setState({
                                      ["name_adult_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  placeholder={
                                    this.state.isMobile
                                      ? "نام خانوادگی فارسی"
                                      : ""
                                  }
                                  disabled={
                                    this.state["disabled_adult_" + index]
                                  }
                                  type="text"
                                  id={"family_adult_" + index}
                                  name={"family_adult_" + index}
                                  value={this.state["family_adult_" + index]}
                                  onChange={(event) => {
                                    this.setState({
                                      ["family_adult_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  placeholder={
                                    this.state.isMobile ? "نام لاتین" : ""
                                  }
                                  disabled={
                                    this.state["disabled_adult_" + index]
                                  }
                                  type="text"
                                  id={"lname_adult_" + index}
                                  name={"lname_adult_" + index}
                                  value={this.state["lname_adult_" + index]}
                                  onChange={(event) => {
                                    this.setState({
                                      ["lname_adult_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_adult_" + index]
                                  }
                                  placeholder={
                                    this.state.isMobile
                                      ? "نام خانوادگی لاتین"
                                      : ""
                                  }
                                  type="text"
                                  id={"lfamily_adult_" + index}
                                  name={"lfamily_adult_" + index}
                                  value={this.state["lfamily_adult_" + index]}
                                  onChange={(event) => {
                                    this.setState({
                                      ["lfamily_adult_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_adult_" + index]
                                  }
                                  type="text"
                                  id={"nationalCode_adult_" + index}
                                  placeholder={
                                    this.state.isMobile ? "کد ملی" : ""
                                  }
                                  name={"nationalCode_adult_" + index}
                                  value={
                                    this.state["nationalCode_adult_" + index]
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["nationalCode_adult_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <DatePicker
                                  onChange={(value) =>
                                    this.setState({
                                      ["birthDate_adult_" + index]: value,
                                    })
                                  }
                                  value={this.state["birthDate_adult_" + index]}
                                  disabled={
                                    this.state["disabled_adult_" + index]
                                  }
                                  isGregorian={false}
                                  timePicker={false}
                                  placeholder="تاریخ تولد"
                                  persianDigits={false}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_adult_" + index]
                                  }
                                  type="text"
                                  placeholder={
                                    this.state.isMobile ? "شماره گذرنامه" : ""
                                  }
                                  id={"passportNum_adult_" + index}
                                  name={"passportNum_adult_" + index}
                                  value={
                                    this.state["passportNum_adult_" + index]
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["passportNum_adult_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_adult_" + index]
                                  }
                                  type="text"
                                  id={"passportDate_adult_" + index}
                                  name={"passportDate_adult_" + index}
                                  value={
                                    this.state["passportDate_adult_" + index]
                                  }
                                  placeholder={
                                    this.state.isMobile
                                      ? "تاریخ انقضا گذرنامه"
                                      : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["passportDate_adult_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                              <select
                                    className="form-control irsans"
                                    disabled={
                                        this.state["disabled_adult_" + index]
                                      }
                                    style={{ width: 90 }}
                                    value={this.state["passenger_adult_" + index]}
                                    onChange={(event) => {
                                        this.setState({
                                            ["passenger_adult_" + index]:
                                              event.target.value,
                                          });
                                    }}
                                >
                                    <option value="Mr">مرد</option>
                                    <option value="Mrs">زن</option>
                                </select>
                               
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_adult_" + index]
                                  }
                                  type="text"
                                  id={"mobile_adult_" + index}
                                  name={"mobile_adult_" + index}
                                  value={
                                    this.state["mobile_adult_" + index]
                                  }
                                  placeholder={
                                    this.state.isMobile
                                      ? "شماره موبایل"
                                      : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["mobile_adult_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div
                                style={{
                                  textAlign: "right",
                                  display: "flex",
                                  height: "100%",
                                  marginTop: 10,
                                  maxWidth: 350,
                                }}
                              >
                                <i
                                  className="fa fa-ban"
                                  style={{ cursor: "pointer", color: "red" }}
                                  aria-hidden="true"
                                  onClick={(event) => {
                                    
                                    const p = {};
                                    p["disabled_adult_" + index] =
                                      !this.state["disabled_adult_" + index];
                                    this.setState({
                                      ...p,
                                    });
                                  }}
                                ></i>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {Array.from(
                        Array(parseInt(this.state.CountArr.kid)).keys()
                      ).map((item, index) => {
                        return (
                          <div
                            style={{
                              alignItems: "baseline",
                              display: "flex",
                              flexWrap: this.state.isMobile ? "wrap" : "nowrap",
                            }}
                            className="mt-2 p-message p-message-info"
                          >
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={this.state["disabled_kid_" + index]}
                                  type="text"
                                  id={"name_kid_" + index}
                                  placeholder={
                                    this.state.isMobile ? "نام فارسی" : ""
                                  }
                                  name={"name_kid_" + index}
                                  value={this.state["name_kid_" + index]}
                                  onChange={(event) => {
                                    this.setState({
                                      ["name_kid_" + index]: event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={this.state["disabled_kid_" + index]}
                                  type="text"
                                  id={"family_kid_" + index}
                                  name={"family_kid_" + index}
                                  value={this.state["family_kid_" + index]}
                                  placeholder={
                                    this.state.isMobile
                                      ? "نام خانوادگی فارسی"
                                      : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["family_kid_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={this.state["disabled_kid_" + index]}
                                  type="text"
                                  id={"lname_kid_" + index}
                                  name={"lname_kid_" + index}
                                  value={this.state["lname_kid_" + index]}
                                  placeholder={
                                    this.state.isMobile ? "نام لاتین" : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["lname_kid_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={this.state["disabled_kid_" + index]}
                                  type="text"
                                  id={"lfamily_kid_" + index}
                                  name={"lfamily_kid_" + index}
                                  value={this.state["lfamily_kid_" + index]}
                                  placeholder={
                                    this.state.isMobile
                                      ? "نام خانوادگی لاتین"
                                      : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["lfamily_kid_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={this.state["disabled_kid_" + index]}
                                  type="text"
                                  id={"nationalCode_kid_" + index}
                                  name={"nationalCode_kid_" + index}
                                  value={
                                    this.state["nationalCode_kid_" + index]
                                  }
                                  placeholder={
                                    this.state.isMobile ? "کد ملی" : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["nationalCode_kid_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <DatePicker
                                  onChange={(value) =>
                                    this.setState({
                                      ["birthDate_kid_" + index]: value,
                                    })
                                  }
                                  value={this.state["birthDate_kid_" + index]}
                                  disabled={this.state["disabled_kid_" + index]}
                                  isGregorian={false}
                                  timePicker={false}
                                  placeholder="تاریخ تولد"
                                  persianDigits={false}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={this.state["disabled_kid_" + index]}
                                  type="text"
                                  id={"passportNum_kid_" + index}
                                  name={"passportNum_kid_" + index}
                                  value={this.state["passportNum_kid_" + index]}
                                  placeholder={
                                    this.state.isMobile ? "شماره گذرنامه" : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["passportNum_kid_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={this.state["disabled_kid_" + index]}
                                  type="text"
                                  id={"passportDate_kid_" + index}
                                  name={"passportDate_kid_" + index}
                                  value={
                                    this.state["passportDate_kid_" + index]
                                  }
                                  placeholder={
                                    this.state.isMobile
                                      ? "تاریخ انقضا گذرنامه"
                                      : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["passportDate_kid_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                              <select
                                     disabled={this.state["disabled_kid_" + index]}
                                    className="form-control irsans"
                                    style={{ width: 90 }}
                                    value={this.state["passenger_kid_" + index]}
                                    onChange={(event) => {
                                        this.setState({
                                            ["passenger_kid_" + index]:
                                              event.target.value,
                                          });
                                    }}
                                >
                                    <option value="Mr">مرد</option>
                                    <option value="Mrs">زن</option>
                                </select>
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_kid_" + index]
                                  }
                                  type="text"
                                  id={"mobile_kid_" + index}
                                  name={"mobile_kid_" + index}
                                  value={
                                    this.state["mobile_kid_" + index]
                                  }
                                  placeholder={
                                    this.state.isMobile
                                      ? "شماره موبایل"
                                      : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["mobile_kid_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>

                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div
                                style={{
                                  textAlign: "right",
                                  display: "flex",
                                  height: "100%",
                                  marginTop: 10,
                                  maxWidth: 350,
                                }}
                              >
                                <i
                                  className="fa fa-ban"
                                  style={{ cursor: "pointer", color: "red" }}
                                  aria-hidden="true"
                                  onClick={(event) => {
                                   
                                    const p = {};
                                    p["disabled_kid_" + index] =
                                      !this.state["disabled_kid_" + index];
                                    this.setState({
                                      ...p,
                                    });
                                  }}
                                ></i>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {Array.from(
                        Array(parseInt(this.state.CountArr.baby)).keys()
                      ).map((item, index) => {
                        return (
                          <div
                            style={{
                              alignItems: "baseline",
                              display: "flex",
                              flexWrap: this.state.isMobile ? "wrap" : "nowrap",
                            }}
                            className="mt-2 p-message p-message-warn "
                          >
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_baby_" + index]
                                  }
                                  placeholder={
                                    this.state.isMobile ? "نام فارسی" : ""
                                  }
                                  type="text"
                                  id={"name_baby_" + index}
                                  name={"name_baby_" + index}
                                  value={this.state["name_baby_" + index]}
                                  onChange={(event) => {
                                    this.setState({
                                      ["name_baby_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_baby_" + index]
                                  }
                                  type="text"
                                  id={"family_baby_" + index}
                                  name={"family_baby_" + index}
                                  value={this.state["family_baby_" + index]}
                                  placeholder={
                                    this.state.isMobile
                                      ? "نام خانوادگی فارسی"
                                      : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["family_baby_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_baby_" + index]
                                  }
                                  type="text"
                                  id={"lname_baby_" + index}
                                  name={"lname_baby_" + index}
                                  value={this.state["lname_baby_" + index]}
                                  placeholder={
                                    this.state.isMobile ? "نام لاتین" : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["lname_baby_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_baby_" + index]
                                  }
                                  type="text"
                                  id={"lfamily_baby_" + index}
                                  name={"lfamily_baby_" + index}
                                  value={this.state["lfamily_baby_" + index]}
                                  placeholder={
                                    this.state.isMobile
                                      ? "نام خانوادگی لاتین"
                                      : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["lfamily_baby_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_baby_" + index]
                                  }
                                  type="text"
                                  id={"nationalCode_baby_" + index}
                                  name={"nationalCode_baby_" + index}
                                  placeholder={
                                    this.state.isMobile ? "کد ملی" : ""
                                  }
                                  value={
                                    this.state["nationalCode_baby_" + index]
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["nationalCode_baby_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <DatePicker
                                  onChange={(value) =>
                                    this.setState({
                                      ["birthDate_baby_" + index]: value,
                                    })
                                  }
                                  value={this.state["birthDate_baby_" + index]}
                                  disabled={
                                    this.state["disabled_baby_" + index]
                                  }
                                  isGregorian={false}
                                  timePicker={false}
                                  placeholder="تاریخ تولد"
                                  persianDigits={false}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_baby_" + index]
                                  }
                                  type="text"
                                  id={"passportNum_baby_" + index}
                                  name={"passportNum_baby_" + index}
                                  value={
                                    this.state["passportNum_baby_" + index]
                                  }
                                  placeholder={
                                    this.state.isMobile ? "شماره گذرنامه" : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["passportNum_baby_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_baby_" + index]
                                  }
                                  type="text"
                                  id={"passportDate_baby_" + index}
                                  name={"passportDate_baby_" + index}
                                  value={
                                    this.state["passportDate_baby_" + index]
                                  }
                                  placeholder={
                                    this.state.isMobile
                                      ? "تاریخ انقضا گذرنامه"
                                      : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["passportDate_baby_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>
                            
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <select
                                    disabled={
                                        this.state["disabled_baby_" + index]
                                    }
                                    
                                    className="form-control irsans"
                                    style={{ width: 90 }}
                                    value={this.state["passenger_baby_" + index]}
                                    onChange={(event) => {
                                        this.setState({
                                            ["passenger_baby_" + index]:
                                              event.target.value,
                                          });
                                    }}
                                >
                                    <option value="Mr">مرد</option>
                                    <option value="Mrs">زن</option>
                                </select>
                              </div>
                            </div>
                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div style={{ textAlign: "right" }}>
                                <input
                                  className="form-control yekan"
                                  autoComplete="off"
                                  disabled={
                                    this.state["disabled_baby_" + index]
                                  }
                                  type="text"
                                  id={"mobile_baby_" + index}
                                  name={"mobile_baby_" + index}
                                  value={
                                    this.state["mobile_baby_" + index]
                                  }
                                  placeholder={
                                    this.state.isMobile
                                      ? "شماره موبایل"
                                      : ""
                                  }
                                  onChange={(event) => {
                                    this.setState({
                                      ["mobile_baby_" + index]:
                                        event.target.value,
                                    });
                                  }}
                                  required="true"
                                  style={{ maxWidth: 350 }}
                                />
                              </div>
                            </div>

                            <div style={{ width: 150, marginLeft: 8 }}>
                              <div
                                style={{
                                  textAlign: "right",
                                  display: "flex",
                                  height: "100%",
                                  marginTop: 10,
                                  maxWidth: 350,
                                }}
                              >
                                <i
                                  className="fa fa-ban"
                                  style={{ cursor: "pointer", color: "red" }}
                                  aria-hidden="true"
                                  onClick={(event) => {
                                    
                                    const p = {};
                                    p["disabled_baby_" + index] =
                                      !this.state["disabled_baby_" + index];
                                    this.setState({
                                      ...p,
                                    });
                                  }}
                                ></i>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Card>
                  </div>
                </Panel>
              )}
              
            </div>
          </form>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(TravelRobot);
